import React, { useState, useRef, useEffect } from 'react'
import {
    Button, TextField, FormControl, InputLabel, MenuItem, Select
} from '@material-ui/core'
import { MuiThemeProvider, createMuiTheme, makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import { useDispatch, useSelector } from "react-redux";
import { modalToggleReset } from 'redux/actions/general'
import { setFilter, getPipeline, getProject, getSummary } from 'redux/actions/pipeline'
import 'react-month-picker/css/month-picker.css';
import Picker from 'react-month-picker'
import AutoCompleteSelect from 'components/Select'

const themeField = createMuiTheme({  
    palette: {  
        primary: {
            main: '#afe597',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#3B99EB',
            contrastText: '#FFFFFF',
        }
    } 
})

const themeButton = createMuiTheme({ 
    palette: { 
        primary: {
            main: '#3B99EB',
        },
        secondary: {
            main: '#ffb100',
            contrastText: '#FFFFFF',
        }
    } 
})

const useStyles = makeStyles(theme => ({
    textField: {
        [`& fieldset`]: {
            borderRadius: 10,
        },
        width: '100%',
        marginBottom: 15
    }
}));

const MonthBox = (props) => {
    const classes = useStyles()

    const _handleClick = (e) => {
        props.onClick && props.onClick(e);
    }

    return (
        <TextField
            label='Deal period'
            value={props.textPeriode}
            onFocus={_handleClick}
            color='primary'
            variant='outlined'
            size='small'
            name='name'
            className={classes.textField}
            readOnly
        />
    )
}

export default function Payment_period(props) {
    const classes = useStyles()
    const dispatch = useDispatch()
    const pipeline = useSelector(state => state.pipeline)
    const master = useSelector(state => state.master)

    // Helper untuk mengambil default (Januari tahun ini s/d Bulan saat ini dalam YYYYMM)
    const defaultFromMonth = moment().startOf('year').format('YYYYMM') // "202601"
    const defaultToMonth = moment().format('YYYYMM')                  // "202608"

    const [filter, stateFilter] = useState({
        tribe: 0,
        segment: 0,
        rm: { label: 'All RM', value: 0 },
        periode: { fromMonth: defaultFromMonth, toMonth: defaultToMonth },
        probability: [],
        rangeValue: {
            from: { year: parseInt(moment().format('YYYY')), month: 1 },
            to: { year: parseInt(moment().format('YYYY')), month: parseInt(moment().format('M')) }
        },
        textPeriode: `Jan. ${moment().format('YYYY')} - ${moment().format('MMM')}. ${moment().format('YYYY')}`
    })

    const { tribe, segment, rm, probability, periode, rangeValue, textPeriode } = filter

    useEffect(() => {
        stateFilter({
            tribe: pipeline.filter.tribe,
            segment: pipeline.filter.segment,
            rm: pipeline.filter.rm,
            periode: pipeline.filter.periode,
            probability: pipeline.filter.probability,
            rangeValue: pipeline.filter.rangeValue,
            textPeriode: pipeline.filter.textPeriode
        })
    }, [])

    const pickRange = useRef(null)

    const onChange = (e) => {
        let { name, value } = e.target
        stateFilter({
            ...filter,
            [name]: value
        })
    }

    const onChangeSelect = (e) => {
        stateFilter({ ...filter, rm: e })
    }

    // Callback saat Month Picker ditutup / selesai memilih range
    const handleRangeDismiss = (value) => {
        let fromMonth = value.from.month > 9 ? `${value.from.year}${value.from.month}` : `${value.from.year}0${value.from.month}`
        let toMonth = value.to.month > 9 ? `${value.to.year}${value.to.month}` : `${value.to.year}0${value.to.month}`
        
        let label = pickerLang.months[value.from.month - 1] + '. ' + value.from.year + ' - ' + pickerLang.months[value.to.month - 1] + '. ' + value.to.year

        stateFilter({
            ...filter,
            periode: { fromMonth: fromMonth, toMonth: toMonth },
            rangeValue: value,
            textPeriode: label
        })
    }

    const onClickSave = async () => {
        dispatch(modalToggleReset())
        
        let map = probability.map((data) => `${data.id}`)
        const probParam = probability.length > 0 ? map.join(',') : 0

        // Kirim format YYYYMM (misal: "202601/202608/0/0/0/0")
        const fromVal = periode.fromMonth || '0'
        const toVal = periode.toMonth || '0'
        const querySlug = `${fromVal}/${toVal}/${tribe}/${segment}/${rm.value}/${probParam}`

        if (master.tab_active === 'pipeline') {
            let res = await dispatch(getPipeline(props.token, querySlug));
            if (res) updateReduxFilter()
        } else if (master.tab_active === 'projection') {
            let res = await dispatch(getProject(props.token, querySlug))
            if (res) updateReduxFilter()
        } else {
            let res = await dispatch(getSummary(props.token, querySlug))
            if (res) updateReduxFilter()
        }
    }

    const updateReduxFilter = () => {
        dispatch(setFilter({ tribe }))
        dispatch(setFilter({ segment }))
        dispatch(setFilter({ rm }))
        dispatch(setFilter({ periode }))
        dispatch(setFilter({ probability }))
        dispatch(setFilter({ rangeValue }))
        dispatch(setFilter({ textPeriode }))
    }

    const onReset = () => {
        stateFilter({
            tribe: 0,
            segment: 0,
            rm: { label: 'All RM', value: 0 },
            periode: { fromMonth: '0', toMonth: '0' },
            probability: [],
            rangeValue: {
                from: { year: parseInt(moment().format('YYYY')), month: 1 },
                to: { year: parseInt(moment().format('YYYY')), month: parseInt(moment().format('M')) }
            },
            textPeriode: 'All Period'
        })
    }

    const data_prob = [
        { id: 10, text: 'Lead (0.1)' },
        { id: 20, text: 'Contact (0.2)' },
        { id: 30, text: 'Meeting & Needs Collected (0.3)' },
        { id: 40, text: 'Proposal Submitted (0.4)' },
        { id: 50, text: 'Proposal Presentation (0.5)' },
        { id: 60, text: 'Like the proposal (0.6)' },
        { id: 70, text: 'Negotiation (0.7)' },
        { id: 80, text: 'Verbally agree (0.8)' },
    ]

    const makeText = m => {
        if (m && m.year && m.month) return (pickerLang.months[m.month - 1] + '. ' + m.year)
        return '?'
    }

    const pickerLang = {
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        from: 'From', to: 'To',
    }

    const _handleClickRangeBox = () => {
        pickRange.current.show()
    }

    const max = moment().add(10, 'year').format('YYYY')
    const min = moment().subtract(10, 'year').format('YYYY')

    return (
        <div>
            <MuiThemeProvider theme={themeField}>
                <FormControl variant="outlined" size="small" className='add-proposal__field'>
                    <InputLabel htmlFor="category">Tribe</InputLabel>
                    <Select name='tribe' value={tribe} onChange={onChange} labelId="label" id="select" labelWidth={40} className='field-radius'>
                        <MenuItem value={0}>All Tribe</MenuItem>
                        {master.tribes.map((data) => (
                            <MenuItem key={data.id} value={data.id}>{data.text}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Month Picker Component */}
                <Picker
                    ref={pickRange}
                    years={{ min: { year: parseInt(min), month: 12 }, max: { year: parseInt(max), month: 12 } }}
                    value={filter.rangeValue}
                    lang={pickerLang}
                    theme="light"
                    onDismiss={handleRangeDismiss}
                >
                    <MonthBox 
                        textPeriode={filter.textPeriode} 
                        value={makeText(filter.rangeValue.from) + ' - ' + makeText(filter.rangeValue.to)} 
                        onClick={_handleClickRangeBox} 
                    />
                </Picker>

                <FormControl variant="outlined" size="small" className='add-proposal__field'>
                    <InputLabel htmlFor="category">Segment</InputLabel>
                    <Select name='segment' value={segment} onChange={onChange} labelId="label" id="select" labelWidth={70} className='field-radius'>
                        <MenuItem value={0}>All segment</MenuItem>
                        {master.segments.map((data) => (
                            <MenuItem key={data.id} value={data.id}>{data.text}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <AutoCompleteSelect
                    onChange={(event, value) => onChangeSelect(value)}
                    options={[{ label: 'All RM', value: 0 }, ...master.rm]}
                    getOptionLabel={(option) => option.label}
                    label={<>Relationship manager</>}
                    value={rm}
                    disableClearable={true}
                />

                {master.tab_active !== 'summary' && (
                    <AutoCompleteSelect
                        multiple
                        onChange={(event, value) => stateFilter({ ...filter, probability: value })}
                        options={data_prob}
                        getOptionLabel={(option) => option.text}
                        label={<>Probability</>}
                        value={probability}
                    />
                )}
            </MuiThemeProvider>

            <MuiThemeProvider theme={themeButton}>
                <div style={{ display: 'flex', padding: '15px 5px 20px 5px', justifyContent: 'space-between' }}>
                    <Button onClick={onReset} size='small' color='primary' variant='text' className='btn-remove-capital'>Reset filter</Button>
                    <Button onClick={onClickSave} size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded' style={{ width: 120, height: 30 }}>Save</Button>
                </div>
            </MuiThemeProvider>
        </div>
    )
}